import axios from 'axios'

const url=process.env.REACT_APP_BASE_URL




export const PostGetOtp=async(number,setAlertMessage,setAlertType,setAlertOpen,setIsLoading,handleClose)=>{
    setIsLoading(true)
    try {
        await axios.post(`${url}/auth/forget_password`,{
            mobile_no:number
        })
        .then(res=>{
            if(res.status===200){
                setAlertMessage(res.data.message)
                setAlertType('success')
                setAlertOpen(true)
                setIsLoading(false)
                handleClose()
            }
        })
    } catch (error) {
        console.log(error);
        setAlertMessage(error.response?error.response.data.error:'Something went wrong!!!')
        setAlertType('error')
        setAlertOpen(true)
        setIsLoading(false)
    }
}


export const PostChangeOtp=async(data,handleAlertOpen, setAlertMessage, setAlertType, setIsLoading)=>{
    try {
        await axios.post(`${url}/auth/verify_forget_password`,data)
        .then(res=>{
            if(res.status===200){
                setAlertMessage(res.data.message)
                setAlertType('success')
                handleAlertOpen()
                setIsLoading(false)
                setTimeout(()=>{
                    window.location.href="/"
                },1000)
            }
        })
    } catch (error) {
        setAlertMessage(error.response?error.response.data.error:'Something went wrong')
        setAlertType('error')
        handleAlertOpen()
        setIsLoading(false)
    }
}